import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "axios";
import Modal from "react-modal";
import * as Constants from "../../Constants/index";
import swal from "sweetalert";
import Text from "react-text";
import { Loading } from "../header/loader.component";
import Swal from "sweetalert2";
import { experienceWithCertification } from "../experience/ExperienceLogo";

class SeatLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      seatCategory: this.props.location.state.seatCategory,

      areacode: this.props.location.state.areacode,
      quantity: this.props.location.state.quantity,
      seats: this.props.location.state.seats,
      ccode: this.props.location.state.cinemaId,
      sessionid: this.props.location.state.sessionId,
      mid: this.props.location.state.mid,
      ttypeCode: this.props.location.state.ttypeCode,
      screenId: "",
      rows: [],
      output: {},
      moviedetail: {},
      showNextButton: 0,
      loading: 1,
      selectedSeats: [],
      ticketPrice: 0,
      prices: [],
      ticketCount: 0,
      transOutput: {},
      seatsToSet: [],
      reserveOutput: {},
      showTrailer: false,
      loading: false,
      agree: false,
      rowSeatValueArr: [],
      // How the rule is switched, sent by the backend with the seat layout.
      // Missing means on, so an older response keeps the rule.
      seatRule: this.props.location.state.seatRule || {},
      // Seats this selection would leave on their own. The banner names them
      // and Proceed stays off while it has anything in it.
      lonelySeats: [],
      // How the seat map should behave, sent with the layout. Missing means
      // the plain behaviour, so an older response changes nothing.
      seatOptions: this.props.location.state.seatOptions || {},
      // A seat the customer reached for that cannot be taken. Only ever set
      // when dimming is off, because dimming makes it unreachable.
      blockedSeat: "",
      doBooking: false,
      bookingsFound:[]
    };
  }
  reserveData = {
    transid: "",
    cinemacode: "",
    sessionid: "",
    reseveSeatVOs: [],
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  // Method to close the modal
  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  componentDidMount() {
    // Nothing is chosen yet, but the dimming and the sweet spot are already
    // decided, so the map has to be marked before the customer touches it.
    this.paintSeats([], []);

    window.scrollTo(0, 0);
    localStorage.removeItem("seatLayoutJson");

    localStorage.removeItem("onlyFood");

    console.log(this.state.seats);
  }
  agree = () => {
    this.setState({ agree: !this.state.agree });
  };

  // A "single empty seat" is one free seat with no free seat next to it in the
  // same row. Sold seats, seats of another area, aisles and the row ends all
  // close a run of free seats.
  findSingleEmptySeats = (takenIds) => {
    const areacode = this.state.areacode;
    const seatRule = this.state.seatRule || {};
    // An aisle and the end of a row count as a wall unless the backend says not to.
    const wallsAtEdges = seatRule.wallsAtEdges !== false;
    const singles = [];

    (this.state.seats || []).forEach((row) => {
      let run = [];
      let leftCloser = "wall";

      const closeRun = (rightCloser) => {
        if (run.length === 1) {
          if (wallsAtEdges || (leftCloser === "taken" && rightCloser === "taken")) {
            singles.push(run[0]);
          }
        }
        run = [];
        leftCloser = rightCloser;
      };

      (row.seats || []).forEach((seat) => {
        const isSeat = seat.display && seat.areacode == areacode;
        const free =
          isSeat && seat.status == "EMPTY" && !takenIds.includes(seat.passingValue);

        if (free) {
          run.push(seat.passingValue);
        } else {
          closeRun(isSeat ? "taken" : "wall");
        }
      });

      closeRun("wall");
    });

    return singles;
  };

  // Single empty seats that this selection makes. Seats that were already
  // single before the customer selected anything do not count.
  newSingleEmptySeats = (seatsToSet) => {
    const before = this.findSingleEmptySeats([]);
    const after = this.findSingleEmptySeats(
      (seatsToSet || []).map((seat) => seat.seatBookingId)
    );

    return after.filter((seatId) => before.indexOf(seatId) === -1);
  };

  // Lengths of every group of free seats next to each other, per row.
  freeRunLengths = (takenIds) => {
    const areacode = this.state.areacode;
    const lengths = [];

    (this.state.seats || []).forEach((row) => {
      let length = 0;
      const closeRun = () => {
        if (length > 0) {
          lengths.push(length);
        }
        length = 0;
      };

      (row.seats || []).forEach((seat) => {
        const bookable =
          seat.display && seat.areacode == areacode && seat.status == "EMPTY";

        if (bookable && !takenIds.includes(seat.passingValue)) {
          length = length + 1;
        } else {
          closeRun();
        }
      });

      closeRun();
    });

    return lengths;
  };

  // Can this show still seat "count" people with no seat left alone?
  //
  // A group of free seats of size L can give away k seats safely when k is the
  // whole group, or k is small enough to leave 2 or more seats behind. Giving
  // away L - 1 always leaves one seat alone, so it is never safe. The groups
  // are then added up to see whether "count" can be reached at all.
  canSeatWithoutSingleEmptySeats = (count) => {
    if (!(count > 0)) {
      return true;
    }

    const reachable = new Array(count + 1).fill(false);
    reachable[0] = true;

    this.freeRunLengths([]).forEach((length) => {
      const safeTakes = [];
      for (let take = 1; take <= length - 2; take++) {
        safeTakes.push(take);
      }
      safeTakes.push(length);

      for (let total = count; total >= 0; total--) {
        if (!reachable[total]) {
          continue;
        }
        safeTakes.forEach((take) => {
          if (total + take <= count) {
            reachable[total + take] = true;
          }
        });
      }
    });

    return reachable[count];
  };

  // The rule only applies while the customer still has a way to obey it. On an
  // almost full show the last free seats can make every choice leave a seat
  // alone, and blocking then just loses the sale.
  mustAvoidSingleEmptySeats = () => {
    const seatRule = this.state.seatRule || {};

    if (seatRule.noSingleEmptySeat === false) {
      return false;
    }
    if (seatRule.relaxWhenFull === false) {
      return true;
    }

    return this.canSeatWithoutSingleEmptySeats(Number(this.state.quantity));
  };

  // ---- the seat map under the customer's finger ------------------------

  lockOn = (name, fallback) => {
    const options = this.state.seatOptions || {};
    if (options.locks === false) {
      return false;
    }
    return options[name] === undefined ? fallback : options[name] !== false;
  };

  // Seats in this row the customer could still take: a real seat, in the area
  // they are buying, free, and not already theirs.
  rowRuns = (row, takenIds) => {
    const areacode = this.state.areacode;
    const runs = [];
    let run = [];

    const closeRun = () => {
      if (run.length) {
        runs.push(run);
      }
      run = [];
    };

    (row.seats || []).forEach((seat) => {
      const open =
        seat.display &&
        seat.areacode == areacode &&
        seat.status == "EMPTY" &&
        !takenIds.includes(seat.passingValue);

      if (open) {
        run.push(seat);
      } else {
        closeRun();
      }
    });

    closeRun();
    return runs;
  };

  // The seat that was tapped, plus the free ones beside it, up to how many the
  // customer still needs. What is left behind on either side must be nothing
  // at all, or two seats and up, so a tap can never strand anybody. Returns
  // null when the seat cannot be taken at all.
  chunkAtSeat = (passingValue, need, seatsToSet) => {
    const takenIds = (seatsToSet || []).map((seat) => seat.seatBookingId);
    const mustObey = this.mustAvoidSingleEmptySeats();

    let found = null;

    (this.state.seats || []).forEach((row) => {
      if (found) {
        return;
      }
      this.rowRuns(row, takenIds).forEach((run) => {
        if (found) {
          return;
        }
        const at = run.findIndex((seat) => seat.passingValue === passingValue);
        if (at === -1) {
          return;
        }

        for (let size = Math.min(need, run.length); size >= 1; size--) {
          // Starts nearest the tapped seat first, so a tap grows rightwards
          // before it reaches back over the seat the customer pointed at.
          const starts = [];
          for (let start = Math.max(0, at - size + 1);
               start <= Math.min(at, run.length - size); start++) {
            starts.push(start);
          }
          starts.sort((a, b) => Math.abs(a - at) - Math.abs(b - at));

          for (let i = 0; i < starts.length; i++) {
            const start = starts[i];
            const leftOver = start;
            const rightOver = run.length - (start + size);
            const legal =
              !mustObey ||
              ((leftOver === 0 || leftOver >= 2) && (rightOver === 0 || rightOver >= 2));

            if (legal) {
              found = run
                .slice(start, start + size)
                .map((seat) => seat.passingValue);
              return;
            }
          }
        }
      });
    });

    return found;
  };

  // Free seats that cannot be taken right now. Dimming them means the customer
  // never makes a choice the page has to take back.
  blockedSeats = (seatsToSet, lonelySeats) => {
    const areacode = this.state.areacode;
    const takenIds = (seatsToSet || []).map((seat) => seat.seatBookingId);
    const need = Number(this.state.quantity) - takenIds.length;
    const blocked = [];
    const grouped = this.lockOn("groupSelection", true);

    (this.state.seats || []).forEach((row) => {
      (row.seats || []).forEach((seat) => {
        const free =
          seat.display &&
          seat.areacode == areacode &&
          seat.status == "EMPTY" &&
          !takenIds.includes(seat.passingValue);

        if (!free) {
          return;
        }

        // While a seat is stranded the only useful taps are that seat itself
        // or one of the customer's own. Anything else makes it worse.
        if (lonelySeats.length > 0) {
          if (!lonelySeats.includes(seat.passingValue)) {
            blocked.push(seat.passingValue);
          }
          return;
        }

        if (need <= 0) {
          return;
        }

        if (!this.chunkAtSeat(seat.passingValue, grouped ? need : 1, seatsToSet)) {
          blocked.push(seat.passingValue);
        }
      });
    });

    return blocked;
  };

  // How good a seat is: about two thirds back from the screen, and in the
  // middle of the row. Only ever drawn when the sweet spot is switched on.
  sweetBand = (rowIndex, rowCount, seat, row) => {
    const shown = (row.seats || []).filter(
      (one) => one.display && one.areacode == this.state.areacode
    );
    if (!shown.length) {
      return 0;
    }

    const first = shown[0].seatnumber;
    const last = shown[shown.length - 1].seatnumber;
    const centre = (Number(first) + Number(last)) / 2;
    const ideal = Math.round(0.65 * (rowCount - 1));

    const score =
      2.2 * Math.abs(rowIndex - ideal) + Math.abs(Number(seat.seatnumber) - centre);

    return Math.min(3, Math.floor(score / 4));
  };

  // Row letter and seat number, the way the customer reads it off the screen.
  seatLabels = (passingValues) => {
    const labels = [];

    (this.state.seats || []).forEach((row) => {
      (row.seats || []).forEach((seat) => {
        if (passingValues.includes(seat.passingValue)) {
          labels.push((row.name || "") + seat.seatnumber);
        }
      });
    });

    return labels.length > 0 ? labels : passingValues;
  };

  // Every mark on the map is put on the element by hand, the same way this
  // page has always toggled "active". A class React does not know about
  // survives its next render; one set through className would be wiped.
  paintSeats = (seatsToSet, lonelySeats) => {
    const clear = (name) =>
      Array.prototype.forEach.call(
        document.querySelectorAll(".seat." + name),
        (element) => element.classList.remove(name)
      );

    clear("lonely");
    clear("blocked");
    for (let band = 0; band <= 3; band++) {
      clear("sweet-" + band);
    }

    const mark = (passingValue, name) => {
      const element = document.getElementById(passingValue);
      if (element) {
        element.classList.add(name);
      }
    };

    lonelySeats.forEach((passingValue) => mark(passingValue, "lonely"));

    if (this.lockOn("dimBlockedSeats", true)) {
      this.blockedSeats(seatsToSet, lonelySeats).forEach((passingValue) =>
        mark(passingValue, "blocked")
      );
    }

    if (this.lockOn("sweetSpot", false)) {
      const rows = this.state.seats || [];
      const takenIds = (seatsToSet || []).map((seat) => seat.seatBookingId);

      rows.forEach((row, rowIndex) => {
        (row.seats || []).forEach((seat) => {
          const free =
            seat.display &&
            seat.areacode == this.state.areacode &&
            seat.status == "EMPTY" &&
            !takenIds.includes(seat.passingValue);

          if (free) {
            mark(seat.passingValue,
                 "sweet-" + this.sweetBand(rowIndex, rows.length, seat, row));
          }
        });
      });
    }
  };

  // The seat numbers behind a set of seats, for the count the page shows.
  seatNumbersOf = (seatsToSet) => {
    const ids = (seatsToSet || []).map((seat) => seat.seatBookingId);
    const numbers = [];

    (this.state.seats || []).forEach((row) => {
      (row.seats || []).forEach((seat) => {
        if (ids.includes(seat.passingValue)) {
          numbers.push(seat.seatnumber);
        }
      });
    });

    return numbers;
  };

  // One place where a changed selection is worked out and drawn, so the marks,
  // the count, the banner and the Proceed button can never disagree.
  applySelection = (seatsToSet, blockedSeat) => {
    const lonelySeats = this.mustAvoidSingleEmptySeats()
      ? this.newSingleEmptySeats(seatsToSet)
      : [];

    Array.prototype.forEach.call(
      document.querySelectorAll(".seat.active"),
      (element) => element.classList.remove("active")
    );
    seatsToSet.forEach((seat) => {
      const element = document.getElementById(seat.seatBookingId);
      if (element) {
        element.classList.add("active");
      }
    });

    this.paintSeats(seatsToSet, lonelySeats);

    this.setState({
      ticketCount: seatsToSet.length,
      selectedSeats: this.seatNumbersOf(seatsToSet),
      seatsToSet: seatsToSet,
      showNextButton: seatsToSet.length > 0 ? 1 : 0,
      lonelySeats: lonelySeats,
      blockedSeat: blockedSeat || "",
    });
  };

  setSeats = () => {
    this.setState({
      isModalOpen:false
    })
    // alert(this.state.seatCategory);

    if (this.state.ticketCount == this.state.quantity) {
      // Safety net. Proceed is already off while a seat would be left alone,
      // so this only catches a way in that does not go through the button.
      const lonelySeats = this.mustAvoidSingleEmptySeats()
        ? this.newSingleEmptySeats(this.state.seatsToSet)
        : [];

      if (lonelySeats.length > 0) {
        this.paintLonelySeats(lonelySeats);
        this.setState({ loading: false, lonelySeats: lonelySeats });
        return;
      }

      this.reserveData.transid = "0";
      this.reserveData.cinemaId = this.state.ccode;
      this.reserveData.sessionid = this.state.sessionid;
      this.reserveData.mid = this.state.mid;
      this.reserveData.category = this.state.seatCategory;

      this.reserveData.reseveSeatVOs = this.state.seatsToSet;

      this.reserveData.ttypeCode = this.state.ttypeCode;
      this.reserveData.areaCode = this.state.areacode;
      this.reserveData.doBooking = this.state.doBooking;
      let token = localStorage.getItem("token");
      try {
        this.setState({
          loading: true,
        });
        axios
          .post(
            Constants.api + "content/trans/reserveseats",
            this.reserveData,

            {
              headers: {
                "Accept-Language": localStorage.getItem("language"),
                appversion: Constants.av,
                platform: window.matchMedia("(max-width: 575px)").matches
                  ? "MSITE"
                  : "WEBSITE",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((resp) => {
            console.log(resp);
            console.log("bookingid");

            console.log(this.state.reserveOutput.bookingid);
            if (resp.data.result === "success") {
              console.log(resp.data.output);
              this.setState({
                reserveOutput: resp.data.output,
              });
              localStorage.setItem("bookingid", resp.data.output.bookingid);
              localStorage.setItem("transid", resp.data.output.transid);
              localStorage.setItem("booktype", resp.data.output.booktype);
              localStorage.removeItem("onlyFood");
              localStorage.setItem("timeout", resp.data.output.timeout);
              if (resp.data.output.fc == "true") {
                window.location = "/food/" + this.state.ccode;
              } else {
                window.location = "/payment/" + this.state.ccode;
              }
            } else {
              console.log(resp.data.msg);
              // swal(resp.data.msg);
              this.setState({isModalOpen:true,bookingsFound:resp.data.output});
              // Swal.fire({
              //   title: "",
              //   text: resp.data.msg,
              //   icon: "question",
              //   showCancelButton: true,
              //   confirmButtonText: "Yes",
              //   cancelButtonText: "Booking History",
              // }).then((result) => {
              //   if (result.isConfirmed) {
              //     // Call the reserveSeats API with doBooking = false
              //     this.setState({ doBooking: true });
              //     this.setSeats();
              //   } else if (result.dismiss === Swal.DismissReason.cancel) {
              //     // Redirect to /myaccount
              //     window.location.href = "/myaccount";
              //   }
              // });

              this.setState({
                loading: false,
                //selectedSeats: [],
              });
              // setTimeout(function () {
              //   window.location.reload();
              // }, 1500);
            }
          })
          .catch((error) => {
            window.location = "/login";
          });
      } catch (err) {
        console.error(err);
      }

      //         } else {
      //           console.log(resp.data.msg);
      //           swal(resp.data.msg);
      //           this.setState({
      //             loading: 0,
      //           });
      //         }
      //         //movie array
      //       });
      //   } catch (err) {
      //     // Handle Error Here
      //     console.error(err);
      //   }
      // };
    } else {
      {
        localStorage.getItem("language") !== "ar"
          ? // swal({
            //   text: "Please select " + this.state.quantity + " seat", "error"
            //   button: "ok",

            // }):

            // swal({
            //   text: "الرجاء التحديد " + this.state.quantity + " مقعد",
            //   button: "نعم",

            // })

            swal("", "Please select " + this.state.quantity + "seat", "error")
          : swal("", "الرجاء التحديد " + this.state.quantity + "مقعد", "error");
      }
    }
  };
  render() {
    const customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "38%",
        padding: "30px 40px 30px 40px",
        borderRadius: "8px",
      },
    };

    const areacode = this.state.areacode;
    const selectSeat = (seatValue) => {
      const { quantity, seatsToSet } = this.state;
      const chosen = seatsToSet.some((seat) => seat.seatBookingId === seatValue);

      // One of the customer's own: let that one seat go. One seat, not the
      // whole group, so a choice can be nudged rather than started again.
      if (chosen) {
        this.applySelection(
          seatsToSet.filter((seat) => seat.seatBookingId !== seatValue)
        );
        return;
      }

      const need = Number(quantity) - seatsToSet.length;
      if (need <= 0) {
        localStorage.getItem("language") !== "ar"
          ? swal({ text: `Please select only ${quantity} seat(s)`, button: "OK" })
          : swal({ text: `الرجاء التحديد ${quantity} مقعد`, button: "نعم" });
        return;
      }

      // One seat per tap is the plain behaviour this page has always had, and
      // it is what the locks being off must give back: the seat is taken, and
      // the banner speaks afterwards if it left somebody alone. Only group
      // picking asks the map where the group can go, and only that can come
      // back with nowhere.
      if (!this.lockOn("groupSelection", true)) {
        this.applySelection(
          seatsToSet.concat([{ seatBookingId: seatValue }])
        );
        return;
      }

      const chunk = this.chunkAtSeat(seatValue, need, seatsToSet);

      // Only reachable when dimming is switched off. With it on, this seat
      // could not have been tapped in the first place.
      if (!chunk) {
        this.applySelection(seatsToSet, seatValue);
        return;
      }

      this.applySelection(
        seatsToSet.concat(chunk.map((id) => ({ seatBookingId: id })))
      );
    };

    return (
      <>
        {this.state.loading ? <Loading /> : ""}

        <div className="seat-banner d-none-mobile">
          <img src={new URL("../../assets/seat-banner.png", import.meta.url).href} alt="" />
          <h3>
            {" "}
            {localStorage.getItem("language") !== "ar" ? (
              "CHOOSE YOUR SEAT"
            ) : (
              <Text>اختر مقعدًا بجولة</Text>
            )}
            <div className="black-width black-width-info"></div>
          </h3>
        </div>
        <div className="home-content-container">
          <div className="seat-banner-page">
            <div className="seats-info-type">
              <div className="seats-info-box">
                <p>
                  {localStorage.getItem("language") !== "ar" ? (
                    "Available"
                  ) : (
                    <Text>متوفرة</Text>
                  )}
                </p>
                <img src={new URL("../../assets/available.png", import.meta.url).href} />
              </div>
              <div className="seats-info-box">
                <p>
                  {localStorage.getItem("language") !== "ar" ? (
                    "Unavailable"
                  ) : (
                    <Text>غير متوفره</Text>
                  )}
                </p>
                <img src={new URL("../../assets/unavailable.png", import.meta.url).href} />
              </div>
              <div className="seats-info-box">
                <p>
                  {localStorage.getItem("language") !== "ar" ? (
                    "Selected"
                  ) : (
                    <Text>المحدد</Text>
                  )}
                </p>
                <img src={new URL("../../assets/selected.png", import.meta.url).href} />
              </div>
            </div>
            <div className="screen-container">
              <img src={new URL("../../assets/Group 1810.png", import.meta.url).href} />
              <p>
                {localStorage.getItem("language") !== "ar" ? (
                  "SCREEN"
                ) : (
                  <Text>شاشة</Text>
                )}
              </p>
            </div>
            <div className="seats-preview-scroll">
              <div className="seats-preview-container">
                <table>
                  {this.state.seats.map(function (item, i) {
                    return (
                      <>
                        {" "}
                        <tr>
                          <td className="row-name">{item.name}</td>

                          {item.seats.map(function (item2, j, arr) {
                            // console.log(arr[j].id);
                            return (
                              <>
                                <span className="table-width">
                                  <td>
                                    <div
                                      className="seat"
                                      id={item2.passingValue}
                                    >
                                      {item2.display ? (
                                        item2.areacode == areacode ? (
                                          item2.status == "EMPTY" ? (
                                            <>
                                              <p
                                                onClick={() =>
                                                  selectSeat(
                                                    item2.passingValue,
                                                    item2.seatnumber,
                                                    item2.areacode,
                                             
                                                    arr[j].id,
                                                    j
                                                  )
                                                }
                                              >
                                                {item2.seatnumber}
                                              </p>
                                              <img
                                                onClick={() =>
                                                  selectSeat(
                                                    item2.passingValue,
                                                    item2.seatnumber,
                                                    item2.areacode,
                                             

                                                    arr[j].id,
                                                    j
                                                  )
                                                }
                                                src={
                                                  new URL("../../assets/seat-default.png", import.meta.url).href
                                                }
                                                alt={item2.seatnumber}
                                              />
                                              <img
                                                onClick={() =>
                                                  selectSeat(
                                                    item2.passingValue,
                                                    item2.seatnumber,
                                                    item2.areacode,
                                             

                                                    arr[j].id,
                                                    j
                                                  )
                                                }
                                                src={
                                                  new URL("../../assets/seat-active.png", import.meta.url).href
                                                }
                                                alt={item2.seatnumber}
                                              />
                                            </>
                                          ) : (
                                            <img
                                              src={
                                                new URL("../../assets/seat-disabled.png", import.meta.url).href
                                              }
                                              alt={item2.seatnumber}
                                            />
                                          )
                                        ) : (
                                          <img
                                            src={
                                              new URL("../../assets/seat-disabled.png", import.meta.url).href
                                            }
                                            alt=""
                                          />
                                        )
                                      ) : (
                                        <> &emsp;</>
                                      )}
                                    </div>
                                  </td>
                                </span>
                              </>
                            );
                          })}
                        </tr>
                      </>
                    );
                  })}
                </table>
              </div>
            </div>
            {this.state.lonelySeats.length === 0 && this.state.blockedSeat ? (
              <div className="seat-notice" role="status">
                <span className="seat-notice-mark">!</span>
                {localStorage.getItem("language") !== "ar" ? (
                  <div>
                    <b>
                      {"Seat " +
                        this.seatLabels([this.state.blockedSeat])[0] +
                        " cannot be taken"}
                    </b>
                    Taking it would leave a seat on its own. Try the seat beside
                    it.
                  </div>
                ) : (
                  <div>
                    <b>
                      {"لا يمكن اختيار المقعد " +
                        this.seatLabels([this.state.blockedSeat])[0]}
                    </b>
                    <Text>
                      اختياره سيترك مقعدًا منفردًا. جرّب المقعد المجاور له.
                    </Text>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {this.state.lonelySeats.length > 0 ? (
              <div className="seat-notice" role="status">
                <span className="seat-notice-mark">!</span>
                {localStorage.getItem("language") !== "ar" ? (
                  <div>
                    <b>
                      {this.state.lonelySeats.length === 1
                        ? "Seat " +
                          this.seatLabels(this.state.lonelySeats)[0] +
                          " would be left on its own"
                        : "Seats " +
                          this.seatLabels(this.state.lonelySeats).join(", ") +
                          " would be left on their own"}
                    </b>
                    Move one of your seats so the gap is two seats or more, or
                    none at all.
                  </div>
                ) : (
                  <div>
                    <b>
                      {"سيبقى المقعد " +
                        this.seatLabels(this.state.lonelySeats).join("، ") +
                        " منفردًا"}
                    </b>
                    <Text>
                      الرجاء تغيير أحد مقاعدك حتى تكون الفجوة مقعدين أو أكثر، أو
                      بدون فجوة.
                    </Text>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            <div className="mob-seats-info">
              {/* <p>Selected Seats</p> */}
              <p className="mob-seats-number">
                {this.state.rowSeatValueArr.join(" | ")}
              </p>
            </div>
            <div className="seating-rules-container">
              <div className="seating-container-head">
                {/* <h4>
                  {localStorage.getItem("language") !== "ar" ? (
                    "Seating Rules"
                  ) : (
                    <Text>قواعد الجلوس</Text>
                  )}
                </h4> */}
                {/* <p>
                  {localStorage.getItem("language") !== "ar" ? (
                    "Violating any of the below will result in non-admittance or exiting the cinema, no refunds will be issues if any of these terms are violated."
                  ) : (
                    <Text>
                      سيؤدي انتهاك أي مما يلي إلى عدم الدخول أو الخروج من
                      السينما ، ولن يتم استرداد أي مشكلة في حالة انتهاك أي من
                      هذه الشروط.
                    </Text>
                  )}
                </p> */}
              </div>
              {/* <div className="seating-list">
                <div className="seating-list-part">
                  <ul>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "All people attending this booking (Age categories exempted from MOH vaccination plan -below the age of 12- are excluded) are required to be vaccinated/recovered and present the IMMUNE app or the Kuwait mobile ID app with their status in green/yellow/orange at the entrance of the cinema."
                      ) : (
                        <Text>
                          يجب على جميع الأشخاص الذين يحضرون هذا الحجز (الفئات
                          العمرية المستثناة من خطة التطعيم بوزارة الصحة -
                          استبعاد سن 12 عامًا - أن يتم تطعيمهم / استعادتهم)
                          وتقديم تطبيق منيع أو تطبيق معرف الهاتف المحمول الكويتي
                          مع وضعهم باللون الأخضر / الأصفر / البرتقالي عند مدخل
                          السينما.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "All people attending this booking need to present their original civil ID or Kuwait mobile ID app to verify their identity."
                      ) : (
                        <Text>
                          يجب على جميع الأشخاص الذين يحضرون هذا الحجز تقديم
                          بطاقتهم المدنية الأصلية أو تطبيق معرف الهاتف المحمول
                          الكويتي للتحقق من هويتهم.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Tickets made in this booking are for groups from the same household."
                      ) : (
                        <Text>
                          التذاكر التي تم إجراؤها في هذا الحجز هي لمجموعات من
                          نفس المنزل.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Wearing a mask at all times is mandatory, it is permitted to remove ONLY when eating/drinking inside the theater."
                      ) : (
                        <Text>
                          ارتداء القناع في جميع الأوقات إلزامي ، ولا يجوز خلعه
                          إلا عند الأكل / الشرب داخل المسرح.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Temperature check must be passed at a maximum of 37.5 degree Celsius"
                      ) : (
                        <Text>
                          يجب اجتياز فحص درجة الحرارة بحد أقصى 37.5 درجة مئوية
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Moving or changing seats without permission is prohibited"
                      ) : (
                        <Text>يحظر نقل أو تغيير المقاعد بدون إذن</Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Two-meter Social distancing between your group and others must be maintained at all times."
                      ) : (
                        <Text>
                          يجب الحفاظ على تباعد اجتماعي بطول مترين بين مجموعتك
                          والآخرين في جميع الأوقات.
                        </Text>
                      )}
                    </li>
                  </ul>
                </div>
                <div className="seating-list-part">
                  <ul>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Tickets are available for collection at the cinema using your Booking ID. If you do not have your Booking ID with you, the tickets cannot be issued."
                      ) : (
                        <Text>
                          التذاكر متاحة للتحصيل في السينما باستخدام معرف الحجز
                          الخاص بك. إذا لم يكن لديك معرف الحجز الخاص بك ، فلا
                          يمكن إصدار التذاكر.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Cancellations are accepted at least two hours before the show starts. No refunds will be issued for bankcard transactions, as we will provide you with credit valid for 30 days, which can be used to book online."
                      ) : (
                        <Text>
                          يتم قبول الإلغاء قبل ساعتين على الأقل من بدء العرض. لن
                          يتم إصدار أي مبالغ مستردة لمعاملات البطاقات المصرفية ،
                          حيث سنوفر لك رصيدًا صالحًا لمدة 30 يومًا ، والذي يمكن
                          استخدامه للحجز عبر الإنترنت.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Cinescape reserves the right to shift your seat in case a free seat is available next or in between your seats."
                      ) : (
                        <Text>
                          تحتفظ Cinescape بالحق في تغيير مقعدك في حالة توفر مقعد
                          مجاني بجوار أو بين مقاعدك.
                        </Text>
                      )}
                    </li>
                    <li>
                      {localStorage.getItem("language") !== "ar" ? (
                        "Children of all ages need tickets for admission."
                      ) : (
                        <Text>
                          يحتاج الأطفال من جميع الأعمار إلى تذاكر للدخول.
                        </Text>
                      )}

                      <ol type="a">
                        <li>
                          {localStorage.getItem("language") !== "ar" ? (
                            "Cinescape reserves the right to shift your seat in case a free seat is available next or in between your seats."
                          ) : (
                            <Text>
                              تحتفظ سينسكيب بالحق في تغيير مقعدك في حالة توفر
                              مقعد مجاني بجوار أو بين مقاعدك.
                            </Text>
                          )}
                        </li>
                        <li>
                          {localStorage.getItem("language") !== "ar" ? (
                            "Children, younger than 3 years, are granted free admissions to all Indian movies (Only one child per guardian is allowed, as children may not occupy a seat)"
                          ) : (
                            <Text>
                              يُمنح الأطفال الذين تقل أعمارهم عن 3 سنوات دخولًا
                              مجانيًا إلى جميع الأفلام الهندية (يُسمح بطفل واحد
                              فقط لكل وصي ، حيث لا يجوز للأطفال شغل مقعد)
                            </Text>
                          )}
                        </li>
                      </ol>
                    </li>
                  </ul>
                </div>
              </div> */}
              {/* <div className="input-check">
                <input
                  type="checkbox"
                  name="agree"
                  id="agree"
                  onClick={() => this.agree()}
                />
                {localStorage.getItem("language") !== "ar" ? (
                  "I agree to the above rules"
                ) : (
                  <Text>أوافق على القواعد المذكورة أعلاه</Text>
                )}
              </div> */}
              {this.state.showNextButton && this.state.lonelySeats.length === 0 ? (
                <div
                  className="proceed-container proceed-btn"
                  onClick={() => this.setSeats()}
                >
                  <button className="btnc btnc-primary">
                    {localStorage.getItem("language") !== "ar" ? (
                      "PROCEED"
                    ) : (
                      <Text>تقدم</Text>
                    )}
                  </button>
                </div>
              ) : (
                <div className="proceed-container proceed-btn">
                  <button className="btnc " disabled>
                    {localStorage.getItem("language") !== "ar" ? (
                      "PROCEED"
                    ) : (
                      <Text>تقدم</Text>
                    )}
                  </button>
                </div>
              )}
            </div>
            {/* <div className="mobile-border-bot"></div> */}
          </div>
        </div>

        <div>
          {/* <button onClick={this.openModal}>Open Modal</button> */}
          <Modal
            isOpen={this.state.isModalOpen}
            onRequestClose={this.closeModal}
            contentLabel="Example Modal"
            style={customStyles}
          >
            {/* <button onClick={this.closeModal} className="icon-close"> <i class="fas fa-times"></i></button> */}
            <div className="modal-bookings scroll-bar">
              <h1>   {localStorage.getItem("language") !== "ar" ? (
              "Bookings Found!"
            ) : (
              <Text>الحجوزات موجودة!</Text>
            )}</h1>
              <div class="timing-slot" id="timing-slot">
                {this.state.bookingsFound.map(function(item,i){
                  return(
                    <>
                     <div class="timing-slot-times time-slot-cinemasessions ">
                  <div class="img-cinemasession">
                    <img
                      src={item.poster}
                      alt={item.moviename}
                    />
                  </div>
                  <div class="movie-cinemasession">
                    <div class="boocking-section">
                      <div class="booking_text">
                      <span className="movie-seat-name">{item.moviename} </span>
                        <span class="age-highlight age_btn new-payment-rating">
                        {item.mcensor}
                        </span>
                      </div>

                      <div class="booking_text booking-date-new">
                        <p>{item.cinemaname} {item.showDate}</p>
                        <p>{experienceWithCertification(item.experience, item.certification, item.certificationAlt)} {item.numofseats} Tickets</p>
                      </div>
                    </div>
                  </div>
                </div>
                    </>
                  )
                })}
               

             
                
              </div>

              <div className="btn-goto">
                <a href="/myaccount?tab=bookings"> <button class="btnc btnc-ghost proceed-btn btn-booking">
                    {localStorage.getItem("language") !== "ar" ? (
              "Go to Bookings"
            ) : (
            <Text>اذهب إلى الحجوزات
          </Text>  )}
                  </button></a> 
                  <button onClick={() => {
                          this.setState({ doBooking: true }, () => {
                            // This callback is executed after the state update is done
                            this.setSeats();
                          });
                        }} class="btnc btnc-ghost proceed-btn btn-booking">
                {localStorage.getItem("language") !== "ar" ? (
              "Continue booking"
            ) : (
            <Text>استمر في الحجز</Text>  )}
                  </button>
                </div>
                
            </div>
          </Modal>
        </div>
      </>
    );
  }
}
export default SeatLayout;
